import { api } from '@marketplace-web/core-api/core-api-client-util'

import { FaqEntriesSearchResp } from '../types/faq-entries-search'

export const searchFaqEntries = (searchText: string) =>
  api.get<FaqEntriesSearchResp, unknown>(`/faq_entries/search?query=${searchText}`)
